import vuelidate from 'vuelidate'

export default vuelidate
